import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/**
 * 싱글페이지에서 앵커 기반 네비게이션바의 활성화/비활성화를 표시합니다
 * 해당 앵커로 스크롤이 이동해도 활성화합니다.
 */
export default class extends Controller {
  static targets = ['nav', 'menu', 'section'];

  scroll() {
    const scrollbarPosition = $(window).scrollTop();
    const sections = this.sectionTargets;
    const nav = this.navTarget;
    const navHeight = $(nav).outerHeight();
    let sectionId = 0;
    sections.forEach((section) => {
      const top = $(section).offset().top - navHeight - 10;
      const bottom = top + $(section).outerHeight();
      if (scrollbarPosition >= top && scrollbarPosition <= bottom) {
        sectionId = section.getAttribute('id');
      }
    });
    if (sectionId === 0) return;
    this.deActiveMenus();

    nav.querySelector(`span[href="#${sectionId}"]`).classList.add('menu-active');
  }

  deActiveMenus() {
    const menus = this.menuTargets;
    menus.forEach((menu) => {
      menu.classList.remove('menu-active');
    });
  }

  moveToSection(e) {
    const navHeight = $(this.navTarget).outerHeight();
    const $el = $(e.currentTarget);
    const id = $el.attr('href');
    const offsetTop = $(id).offset().top;
    const scrollTop = offsetTop - navHeight;

    if (id === undefined) return false;

    $('html, body').animate(
      {
        scrollTop,
      },
      500,
    );

    return false;
  }

  moveToElementId(e) {
    const navHeight = $(this.navTarget).outerHeight();
    const offsetTop = $(`#${e.params.id}`).offset().top;
    const scrollTop = offsetTop - navHeight;

    $('html, body').animate(
      {
        scrollTop,
      },
      500,
    );

    return false;
  }

  scrollToTargetParent(e) {
    const level = Number(e.params.level);
    let target = e.currentTarget;
    for (let i = 0; i < level; i++) {
      if (target.parentElement !== null) {
        target = target.parentElement;
      }
    }
    const navHeight = $(document.getElementById('nav')).outerHeight();
    const offsetTop = $(target).offset().top;
    const scrollTop = offsetTop - navHeight - 10;

    $('html, body').animate(
      {
        scrollTop,
      },
      500,
    );

    return false;
  }
}
